import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, OnDestroy, Input, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { createWorker } from 'tesseract.js';
let cv = (window as any).cv;

@Component({
  selector: 'app-webcam-dialog',
  templateUrl: './webcam-dialog.component.html',
  styleUrls: ['./webcam-dialog.component.scss']
})
export class WebcamDialogComponent implements OnInit, OnDestroy {
  
  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvasElement') canvasElement!: ElementRef<HTMLCanvasElement>;
  @Input() opcion: number = 0;
  @Output() imageCaptured = new EventEmitter<{ image: string; opcion: number }>();
  @Output() capturaReiniciada = new EventEmitter<{ opcion: number }>();
  
  title = 'Captura de '
  public devices: MediaDeviceInfo[] = [];
  public selectedDeviceId: string | null = null;
  public stream: MediaStream | null = null;
  public capturedImage: string | null = null;
  showImage = false
  reloadDevices = true

  cvReady: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,  public dialogRef: MatDialogRef<WebcamDialogComponent>){
    this.title = data.title
  }

  async ngOnInit(): Promise<void> {
    await this.loadDevices(1);
    this.waitForOpenCV();
    try {
      await this.startCameraWithFacingMode("environment");
    } catch (err) {
      console.warn("No se pudo abrir la cámara trasera, usando lista de dispositivos:", err);

      // Si falla, usar la lista de dispositivos y abrir el primero
      if (this.devices.length > 0) {
        this.selectedDeviceId = this.devices[0].deviceId;
        await this.startCamera(this.selectedDeviceId);
      } else {
        alert("No hay cámaras disponibles para seleccionar");
      }
    }
  }

  waitForOpenCV() {
    const check = () => {
      if (typeof cv !== 'undefined' && typeof cv.imread === 'function') {
        this.cvReady = true;
        // console.log('✅ OpenCV.js está listo');
      } else {
        setTimeout(check, 100);
      }
    };
    check();
  }

  async loadDevices(opc): Promise<void> {
    if(!this.reloadDevices){
      return
    }
    if(opc === 2 ){
      this.reloadDevices = false
    }
    const allDevices = await navigator.mediaDevices.enumerateDevices();
    this.devices = allDevices.filter(d => d.kind === 'videoinput');

    // Buscar cámara trasera
    const backCamera = this.devices.find(d =>
      d.label.toLowerCase().includes("back") ||
      d.label.toLowerCase().includes("rear") ||
      d.label.toLowerCase().includes("trasera") ||
      d.label.toLowerCase().includes("posterior") ||
      d.label.toLowerCase().includes("environment")
    );

    if (backCamera) {
      this.selectedDeviceId = backCamera.deviceId;
      this.startCamera(this.selectedDeviceId)
    }
  }

  async startCamera(deviceId: string): Promise<void> {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
    }

    try {
      const constraints = {
        video: deviceId ? { deviceId: { exact: deviceId } } : true,
      };
      this.stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.videoElement.nativeElement.srcObject = this.stream;
      this.videoElement.nativeElement.play();

      await this.loadDevices(2);
    } catch (err) {
      console.error('Error al iniciar la cámara:', err);
    }
  }

  async startCameraWithFacingMode(facingMode: "user" | "environment"): Promise<void> {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: { exact: facingMode } }
    });
    const videoElement = document.querySelector("video");
    if (videoElement) {
      videoElement.srcObject = stream;
    }
    this.loadDevices(2)
  }

  async onDeviceChange(event: Event): Promise<void> {
    const deviceId = (event.target as HTMLSelectElement).value;
    this.selectedDeviceId = deviceId;
    await this.startCamera(deviceId);
  }

  async captureImage() {
    
    this.showImage = true
    const video = this.videoElement.nativeElement;
    const canvas = this.canvasElement.nativeElement;
    canvas.width = video.videoWidth * 2;
    canvas.height = video.videoHeight * 2;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Captura el frame del video
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    // Convierte el canvas procesado a imagen base64
    this.capturedImage = canvas.toDataURL('image/png');

    // const worker = await createWorker('spa');
    // await worker.load();
    // await worker.setParameters({
    //   tessedit_char_whitelist: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-'
    // });

    // const { data } = await worker.recognize(this.capturedImage);
    // console.log(data.text);
    // console.log(data.text.split('\n'));
    // this.capturedImage = this.capturedImage
    // await worker.terminate();
  }

  async reintentar(){
    this.showImage = false
    this.capturedImage = null;

    try {
      const constraints = {
        video: { deviceId: { exact: this.selectedDeviceId} }
      };
      this.stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.videoElement.nativeElement.srcObject = this.stream;
      this.videoElement.nativeElement.play();
    } catch (err) {
      console.error('Error al iniciar la cámara:', err);
    }
  }

  continuar(): void {
    if (this.capturedImage) {
      this.dialogRef.close({event: 1, imagen: this.capturedImage})
    }
  }

  ngOnDestroy(): void {
    this.stopCamera()
  }

  stopCamera(): void {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }

  closeDialog(){
    this.dialogRef.close({event: 2})
  }
}
